import api from 'api-client'

const state = {
    users: [],
    orders: [],
    orderhistoryFilters: []
}

const getters = {
    users: state => {
        return state.users
    },
    orders: state => {
        return state.orders
    },
    orderhistoryFilters: state => state.orderhistoryFilters
}

const mutations = {
    users(state, users) {
        state.users = users
    },
    orders(state, orders) {
        state.orders = orders
    },
    markOderAsPaid(state, params) {
        const order = state.orders.data.find(order => order.id === params.id)
        order.PaymentStatus = !order.PaymentStatus
    },
    markOderAsShipped(state, params) {
        const order = state.orders.data.find(order => order.id === params.id)
        order.ShippingStatus = !!params.ShippingTrackingNumber
    },
    markOderAsPlacedWithFOHES(state, params) {
        const order = state.orders.data.find(order => order.id === params.id)
        order.PlacedByFohes = !!params.FOHESInvoiceNumber && !!params.FOHESConfirmationNumber
    },
    orderhistoryFilters(state, filters) {
        state.orderhistoryFilters = filters
    },
    markOderAsOrderInfo(state, params) {
        const order = state.orders.data.find(order => order.id === params.id)
        order.OrderInfo = !!params.OrderInfo
    },
    markOderAsPaymentDate(state, params) {
        const order = state.orders.data.find(order => order.id === params.id)
        order.payment_date = params.PaymentDate
        order.payment_date_deadline = params.PaymentDateDeadline
    },
}

const actions = {
    getUsers(state) {
        return api.findUsers({}).then(result => state.commit('users', result))
    },
    getEditableUsers(state) {
        return api.findEditableUsers({}).then(result => state.commit('users', result))
    },
    updateUser({ dispatch }, user) {
        return api.updateUser(user).then(() => dispatch('getUsers'))
    },
    removeUser({ dispatch }, id) {
        return api.removeUser(id).then(() => dispatch('getUsers'))
    },
    getOrderArticles(state, orderId) {
        return api.getOrderArticles(orderId)
    },
    getOrderAddress(state, customerId) {
        return api.getOrderAddress(customerId)
    },
    markOrderAsPaid({ commit }, params) {
        return api.markOrderAsPaid(params).then(() => commit('markOderAsPaid', params))
    },
    markOrderAsShipped({ commit }, params) {
        return api.markOrderAsShipped(params).then(() => commit('markOderAsShipped', params))
    },
    saveRequiredLogo(_, params) {
        return api.saveRequiredLogo(params)
    },
    saveOrderInfo(_, params) {
        return api.saveOrderInfo(params).then(() => commit('markOderAsOrderInfo', params))
    },
    saveOrderPaymentDate({ commit }, params) {
        console.log(params)
        return api.saveOrderPaymentDate(params).then(() => commit('markOderAsPaymentDate', params))
    },
    markOrderAsPlacedWithFOHES({ commit }, params) {
        return api.markOrderAsPlacedWithFOHES(params).then(() => commit('markOderAsPlacedWithFOHES', params))
    },
    createUser(state, params) {
        return api.createUser(params)
    },
    getOrders({ commit, dispatch }, params) {
        return api.getOrders(params).then(result => {
            // Manipuliere die Daten über die separate Aktion
            dispatch('manipulateOrderShortNames', result.data).then(manipulatedOrders => {
                commit('orders', { data: manipulatedOrders }) // Speichere die manipulierten Daten im Store
            });
            return result
        })
    },
    manipulateOrderShortNames({ commit }, orders) {
        return new Promise((resolve) => {
            const manipulatedOrders = orders.map(order => {
                
                if (order.ShortName === 'PARTNER') {
                    if (order.isContractual === 1) {
                        order.ShortName = 'ORBR - Contractual';
                    } else {
                        order.ShortName = 'ORBR Partner Paid';
                    }
                } 
                else if (order.ShortName === 'VCARB Partner') {
                    if (order.isContractual === 1) {
                        order.ShortName = 'VCARB - Contractual';
                    } else {
                        order.ShortName = 'VCARB Partner Paid';
                    }
                } 
                else {
                    if (order.ShortName === 'INCENTIVE') {
                        order.ShortName = 'Agency';
                    } 
                }
                return order;
            });

            resolve(manipulatedOrders);
        });
    },
    recreateOrderCache(state, params) {
        return api.recreateOrderCache()
    },
    getOrderhistoryFiltersForUser({ commit }) {
        return api.getOrderhistoryFiltersForUser().then(result => {
            commit('orderhistoryFilters', result)
            return result
        })
    },
    insertOrderhistoryFilter(state, filter) {
        return api.insertOrderhistoryFilter(filter)
    },
    deleteOrderhistoryFilter(state, filterId) {
        return api.deleteOrderhistoryFilter(filterId)
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
